/* ==========================================================================
   MT — Interacciones. Todo vanilla, sin librerías.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveals al hacer scroll (un solo observador compartido) ------------ */
  function initReveals() {
    var elems = document.querySelectorAll('.mt-reveal, .mt-reveal-escala, .mt-reveal-mascara, .mt-anim');
    if (!elems.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      elems.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('mt-visible');
        obs.unobserve(e.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

    elems.forEach(function (el) { obs.observe(el); });
  }

  /* ---- Cifras que cuentan hacia arriba ----------------------------------- */
  function initContadores() {
    var nums = document.querySelectorAll('[data-mt-contador]');
    if (!nums.length) return;

    function pinta(el, valor) {
      var dec = parseInt(el.getAttribute('data-mt-decimales') || '0', 10);
      var txt = valor.toFixed(dec).replace('.', ',');
      el.firstChild && el.firstChild.nodeType === 3
        ? (el.firstChild.nodeValue = txt)
        : (el.insertBefore(document.createTextNode(txt), el.firstChild));
    }

    function anima(el) {
      var fin = parseFloat(el.getAttribute('data-mt-contador'));
      if (isNaN(fin)) return;
      if (reduce) { pinta(el, fin); return; }
      var dur = 1600, ini = null;
      function paso(t) {
        if (ini === null) ini = t;
        var p = Math.min((t - ini) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        pinta(el, fin * e);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      nums.forEach(function (el) { anima(el); });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        anima(e.target);
        obs.unobserve(e.target);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (el) { pinta(el, 0); obs.observe(el); });
  }

  /* ---- Parallax suave del hero (solo transform) -------------------------- */
  function initParallax() {
    var capas = document.querySelectorAll('[data-mt-parallax]');
    if (!capas.length || reduce) return;
    if (window.innerWidth < 900) return;

    var pendiente = false;
    function actualiza() {
      pendiente = false;
      capas.forEach(function (capa) {
        var fuerza = parseFloat(capa.getAttribute('data-mt-parallax')) || 0;
        if (!fuerza) return;
        var caja = capa.getBoundingClientRect();
        if (caja.bottom < -200 || caja.top > window.innerHeight + 200) return;
        var centro = caja.top + caja.height / 2 - window.innerHeight / 2;
        var img = capa.querySelector('img');
        if (img) img.style.transform = 'scale(1.09) translate3d(0,' + (-centro * fuerza / 100) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(actualiza);
    }, { passive: true });
    actualiza();
  }

  /* ---- Selector de color en la sección de tamaños ------------------------ */
  function initSelectorColor() {
    var grupos = document.querySelectorAll('[data-mt-colores]');
    if (!grupos.length) return;

    grupos.forEach(function (grupo) {
      var botones = grupo.querySelectorAll('.mt-tam__opcion');
      var raiz = grupo.closest('.mt-tam');
      if (!raiz) return;

      botones.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var color = btn.getAttribute('data-color');
          botones.forEach(function (b) {
            b.setAttribute('aria-selected', String(b === btn));
          });
          raiz.querySelectorAll('.mt-tam__foto img').forEach(function (img) {
            img.classList.toggle('mt-activa', img.getAttribute('data-color') === color);
          });
        });
      });
    });
  }

  /* ---- Galería de la página de producto ---------------------------------- */
  function initGaleria() {
    var galerias = document.querySelectorAll('[data-mt-galeria]');
    if (!galerias.length) return;

    galerias.forEach(function (gal) {
      var minis = gal.querySelectorAll('.mt-prod__mini');
      var grandes = gal.querySelectorAll('.mt-prod__principal img');

      function activa(i) {
        minis.forEach(function (m, k) { m.setAttribute('aria-current', String(k === i)); });
        grandes.forEach(function (g, k) { g.classList.toggle('mt-activa', k === i); });
      }

      minis.forEach(function (m, i) {
        m.addEventListener('click', function () { activa(i); });
      });
    });
  }

  /* ---- Selector de variantes de la página de producto -------------------- */
  function initVariantes() {
    var bloques = document.querySelectorAll('[data-mt-variantes]');
    if (!bloques.length) return;

    bloques.forEach(function (bloque) {
      var datos;
      try {
        datos = JSON.parse(bloque.querySelector('[data-mt-variantes-json]').textContent);
      } catch (e) { return; }

      var campo = bloque.querySelector('[name="id"]');
      var precioEl = bloque.querySelector('[data-mt-precio]');
      var boton = bloque.querySelector('[data-mt-comprar]');
      var swatches = bloque.querySelectorAll('.mt-prod__swatch');
      var seleccion = {};

      swatches.forEach(function (s) {
        if (s.getAttribute('aria-checked') === 'true') {
          seleccion[s.getAttribute('data-opcion')] = s.getAttribute('data-valor');
        }
      });

      function buscaVariante() {
        return datos.find(function (v) {
          return v.opciones.every(function (o, i) {
            return seleccion[String(i)] === o;
          });
        });
      }

      function refresca() {
        var v = buscaVariante();
        if (!v) return;
        if (campo) campo.value = v.id;
        if (precioEl) precioEl.innerHTML = v.precio;
        if (boton) {
          boton.disabled = !v.disponible;
          var etq = boton.querySelector('[data-mt-etq]');
          if (etq) etq.textContent = v.disponible ? boton.getAttribute('data-mt-texto') : 'Agotado';
        }
        // imagen asociada a la variante
        if (v.imagen !== null && v.imagen !== undefined) {
          var gal = document.querySelector('[data-mt-galeria]');
          if (gal) {
            var mini = gal.querySelector('.mt-prod__mini[data-idx="' + v.imagen + '"]');
            if (mini) mini.click();
          }
        }
      }

      swatches.forEach(function (s) {
        s.addEventListener('click', function () {
          var op = s.getAttribute('data-opcion');
          seleccion[op] = s.getAttribute('data-valor');
          bloque.querySelectorAll('.mt-prod__swatch[data-opcion="' + op + '"]').forEach(function (o) {
            o.setAttribute('aria-checked', String(o === s));
          });
          refresca();
        });
      });

      refresca();
    });
  }

  /* ---- Marquesina: duplica el contenido para bucle infinito -------------- */
  function initMarquesinas() {
    document.querySelectorAll('.mt-marq').forEach(function (m) {
      var pista = m.querySelector('.mt-marq__pista');
      if (!pista || pista.dataset.mtClonada) return;
      var clon = pista.cloneNode(true);
      clon.setAttribute('aria-hidden', 'true');
      m.appendChild(clon);
      pista.dataset.mtClonada = '1';
    });
  }

  /* ---- Acordeón FAQ: solo uno abierto a la vez --------------------------- */
  function initFaq() {
    document.querySelectorAll('[data-mt-faq]').forEach(function (lista) {
      var items = lista.querySelectorAll('details');
      items.forEach(function (it) {
        it.addEventListener('toggle', function () {
          if (!it.open) return;
          items.forEach(function (o) { if (o !== it) o.open = false; });
        });
      });
    });
  }

  /* ---- Arranque ---------------------------------------------------------- */
  function arranca() {
    initReveals();
    initContadores();
    initParallax();
    initSelectorColor();
    initGaleria();
    initVariantes();
    initMarquesinas();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }

  // El editor de Shopify recarga secciones sueltas: rearrancamos.
  document.addEventListener('shopify:section:load', arranca);
})();
